export default "__VITE_ASSET__Co8eGKY5__"